import { AccordionV2 } from "@circle-react-uikit/AccordionV2";
import { ContentSpecAccessGroupsControl } from "@circle-react/components/shared/AccessRegistry/ContentSpecAccessGroupsControl";
import { contentSpecTypes } from "@circle-react/types/AccessRegistry";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

export const CONTENT_HARD_DELETION_DELAY_KEY =
  "spaces.delete.content_hard_deletion_delay";

interface DetailsProps {
  description: string;
  spaceGroupId: number;
  spaces: Array<{ id: number; name: string }>;
}

export const Details = ({
  description,
  spaces,
  spaceGroupId,
}: DetailsProps) => (
  <div className="flex flex-col gap-y-5">
    <Typography.BodyMd>{description}</Typography.BodyMd>
    {spaces.length > 0 && (
      <AccordionV2
        title={t("space_groups.delete.spaces_count", { count: spaces.length })}
        defaultExpanded={spaces.length <= 5}
      >
        <AccordionV2.BulletedList items={spaces.map(space => space.name)} />
      </AccordionV2>
    )}
    <ContentSpecAccessGroupsControl
      contentSpecType={contentSpecTypes.SpaceGroup}
      contentSpecId={spaceGroupId}
    />
  </div>
);
